"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.AssociatedAsset=void 0;var r;(function(e){e.InStorePrices="InStorePrices",e.CartSaved="cart_saved",e.OngoingOrder="ongoing_order"})(r||(exports.AssociatedAsset=r={}));
//# sourceMappingURL=AssociatedAsset.js.map
